<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";

export default {
  name: 'linechart',
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "折线图",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "日期",
    },
    yAxisName: {
      type: String,
      default: "数量",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions();
    },
    setOptions() {
      this.chart.setOption({
        title: {
          text: this.title,
          textStyle: {
            fontSize: 16,
            color: "#c0c3cd",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
            shadowStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(255,255,255,.0)",
                  },
                  {
                    offset: 1,
                    color: "rgba(0,90,173)",
                  },
                ],
              },
            },
          },
        },
        grid: {
          top: 35,
          left: "3%",
          right: "6%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            name: this.xAxisName,
            nameTextStyle: {
              color: "#c0c3cd",
              fontSize: 12,
            },
            data: this.chartData.days,
            axisLine: {
              show: true,
              lineStyle: {
                color: "#205189",
                width: 3,
              },
            },
            axisLabel: {
              color: "#c0c3cd",
              fontSize: 12,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: this.yAxisName,
            nameTextStyle: {
              color: "#c0c3cd",
              padding: [0, 80, 0, 0],
              fontSize: 12,
            },
            axisLabel: {
              color: "#c0c3cd",
              fontSize: 12,
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#205189",
                width: 3,
              },
            },
            splitLine: {
              lineStyle: {
                type: "dashed",
                color: "rgb(37,82,121)",
                width: 3,
              },
            },
          },
        ],
        series: [
          {
            type: "line",
            data: this.chartData.data,
            symbol: "circle",
            symbolSize: 8,
            lineStyle: {
              normal: {
                color: "rgb(0,105,206)",
                width: 3,
              },
            },
            itemStyle: {
              color: "rgb(140,195,255)",
              shadowBlur: 5,
              shadowColor: "#fff",
            },
          },
        ],
      });
    },
  },
};
</script>
